import { Container } from '@mui/material';
import { navigate, type PageProps } from 'gatsby';
import React from 'react';
import { type FallbackProps, withErrorBoundary } from 'react-error-boundary';
import { defineMessages, useIntl } from 'react-intl';

import { DrilldownHeader } from '@components/DrilldownHeader';
import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';

import AppLayout from '@layouts/AppLayout';

import { TrackerType } from '@models/vital-sign';

import HealthTrackerDrilldown from '@views/Records/HealthTracker/Drilldown';

const messages = defineMessages({
  fallbackTitle: {
    defaultMessage: 'Health Score',
    id: 'fallbackDrilldown.healthScore',
  },
});

function HealthScoreDrilldown({ params }: PageProps) {
  return (
    <>
      <HealthTrackerDrilldown
        category={TrackerType.HealthScore}
        showAlerts={false}
        type={params.id}
      />
    </>
  );
}

const Fallback = (props: FallbackProps) => {
  const { formatMessage } = useIntl();
  const title = formatMessage(messages.fallbackTitle);

  return (
    <AppLayout friendlyName={title}>
      <DrilldownHeader onBackClick={() => navigate(-1)} title={title} />
      <Container maxWidth="md">
        <ErrorBoundaryFallback {...props} />
      </Container>
    </AppLayout>
  );
};

export default withErrorBoundary(HealthScoreDrilldown, {
  FallbackComponent: (props) => <Fallback {...props} />,
});
